import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { BookCategory } from "@modules/bookCategories/types";
import { BookCategoryFormValues } from "@modules/bookCategories/validations";

export async function createBookCategoryService(
  data: BookCategoryFormValues
): Promise<BookCategory> {
  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: bookCategory } = await api.post<BookCategory>(
    "v1/book_category_admin/",
    formatedData,
    { headers }
  );

  return bookCategory;
}
